import * as yup from "yup";

declare module "yup" {
   export interface ArraySchema<T> {
      /**
       * Check array for unique elements.
       *       
       * @param {String} [field=field_name] Is required.
       * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
       */
      unique(
         field: string,
         errorMessage?: string
      ): ArraySchema<T>;
   }
}

const YUP_UNIQUE_METHOD = "unique";
yup.addMethod(yup.array, YUP_UNIQUE_METHOD, function (field, message) {
   return this.test(YUP_UNIQUE_METHOD, message, function (array) {
      if (!array) {
         return true;
      }
      const notNullArray = array.filter(row => row);
      const uniqueData = Array.from(
         new Set(notNullArray.map((row) => row[field]?.toLowerCase())),
      );
      const isUnique = notNullArray.length === uniqueData.length;
      if (isUnique) {
         return true;
      }
      const index = notNullArray.findIndex(
         (row, i) => row[field]?.toLowerCase() !== uniqueData[i],
      );

      if (index == -1 || notNullArray[index][field] === "") {
         return true;
      }
      const repeatedValue = notNullArray[index][field];

      const firstIndex = array.findIndex(
         (row, i) => row && row[field]?.toLowerCase() === repeatedValue);

      const secondIndex = array.findIndex(
         (row, i) => i > firstIndex && row && row[field]?.toLowerCase() === repeatedValue);

      return this.createError({
         path: `${this.path}.${secondIndex}.${field}`,
         message,
      });
   });
});